// Purpose: Setting/credential API calls
// Caller: settingAction
// Dependencies: utils/xhr
// Main Functions: generateCredShopee
// Side Effects: HTTP POST /cred/shopee/generate/access-token

import { xhr } from 'utils'

export const generateCredShopee = (data) => xhr.post('/cred/shopee/generate/access-token', data)
